module.exports = __webpack_public_path__ + "static/media/video-based.63ddd71f.svg";